<div class="overLayDiv active"
     *ngIf="isOverlayRequired"></div>

<div id="rightSideBar">
  <div class="rightSidePanel w-50pc active z-99999">
    <header class="panel-header">
      <div class="viewDemo title-and-video">
          <h2>{{ 'office_address_select' | translate }}</h2>
      </div>            
      <div class="panel-left-btn">
          <button type="button" class="btn eod-btn-outline-warning" (click)="onClosePanel()">
            {{ 'close' | translate }}
          </button>
      </div>
    </header>
    <div class="block heightCalc-5">
      <div class="row">
        <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 no-padding-right-left heightCalc-13">
          <app-grid [columns]="gridColumnDefs"
                    [data]="gridData"
                    [gridConfigItems]="gridConfigItems"
                    (onCellClick)="fnOnGridCellClick($event)">
          </app-grid>
        </div>
      </div>
    </div>
  </div>
</div>